// Complete data for all 8 example websites
// Each site uses max 2 images: heroImage + aboutImage
const IMG = {
  coffee: {
    hero: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=1600&h=900&fit=crop&q=70",
    interior: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=600&h=400&fit=crop&q=60",
  },
  lash: {
    hero: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1600&h=900&fit=crop&q=70",
    salon: "https://images.unsplash.com/photo-1633681926022-84c23e8cb2d6?w=600&h=400&fit=crop&q=60",
  },
  plumbing: {
    hero: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=1600&h=900&fit=crop&q=70",
    work: "https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=600&h=400&fit=crop&q=60",
  },
  flowers: {
    hero: "https://images.unsplash.com/photo-1560597324-f8e931d1339d?w=1600&h=900&fit=crop&q=70",
    florist: "https://images.unsplash.com/photo-1593011951342-8426e949371f?w=600&h=400&fit=crop&q=60",
  },
  landscape: {
    hero: "https://images.unsplash.com/photo-1558904541-efa843a96f01?w=1600&h=900&fit=crop&q=70",
    garden: "https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?w=600&h=400&fit=crop&q=60",
  },
  pet: {
    hero: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=1600&h=900&fit=crop&q=70",
    groomed: "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=600&h=400&fit=crop&q=60",
  },
  bakery: {
    hero: "https://images.unsplash.com/photo-1509440159596-0249088772ff?w=1600&h=900&fit=crop&q=70",
    baker: "https://images.unsplash.com/photo-1556217477-d325251ece38?w=600&h=400&fit=crop&q=60",
  },
};

export const SITES = {
  "sunrise-coffee": {
    name: "Sunrise Coffee Co.",
    slug: "sunrise-coffee",
    phone: "(480) 555-1234",
    email: "hello@sunrisecoffee.com",
    address: "123 Main Street, Queen Creek, AZ 85142",
    colors: {
      primary: "#78350F",
      secondary: "#D4A373",
      bg: "#FFFBEB",
      accent: "#C2410C",
      text: "#292524",
      lightBg: "#FFF8EE",
    },
    headingFont: "'DM Serif Display', Georgia, serif",
    navItems: ["Menu", "About", "Visit"],
    ctaText: "Order Online",
    secondaryCta: "Visit Us",
    heroImage: IMG.coffee.hero,
    heroTitle: "Sunrise Coffee Co.",
    heroSubtitle:
      "Locally roasted. Locally loved. A neighborhood coffee shop in Queen Creek since 2019.",
    servicesTitle: "Our Menu",
    servicesLayout: "cards",
    services: [
      {
        name: "Espresso Drinks",
        desc: "Crafted with locally roasted beans",
        items: [
          { name: "Espresso", price: "$3.50" },
          { name: "Cappuccino", price: "$5.00" },
          { name: "Latte", price: "$5.50" },
          { name: "Mocha", price: "$6.00" },
        ],
      },
      {
        name: "Cold Brew & Iced",
        desc: "Smooth and refreshing",
        items: [
          { name: "Classic Cold Brew", price: "$4.50" },
          { name: "Iced Latte", price: "$5.50" },
          { name: "Iced Mocha", price: "$6.00" },
          { name: "Cold Brew Float", price: "$6.50" },
        ],
      },
      {
        name: "Fresh Pastries",
        desc: "Baked in-house daily",
        items: [
          { name: "Croissant", price: "$3.50" },
          { name: "Blueberry Muffin", price: "$3.00" },
          { name: "Banana Bread", price: "$3.50" },
          { name: "Scone", price: "$3.00" },
        ],
      },
    ],
    aboutTitle: "Brewed in Queen Creek since 2019",
    aboutText:
      "What started as a dream between two friends has grown into Queen Creek's favorite morning stop. We source our beans from small farms, roast them in-house, and brew every cup with care. We believe great coffee brings people together.",
    aboutText2:
      "Stop by, grab a latte, say hi. We know most of our regulars by name, and we'd love to know yours.",
    aboutImage: IMG.coffee.interior,
    testimonials: [
      {
        quote: "Best coffee in Queen Creek, hands down. The cold brew is unreal.",
        name: "Sarah M.",
        location: "Queen Creek, AZ",
        avatarId: 5,
      },
      {
        quote:
          "We come here every Saturday morning. The pastries are always fresh and the staff is wonderful.",
        name: "David R.",
        location: "San Tan Valley, AZ",
        avatarId: 12,
      },
      {
        quote:
          "Finally a real coffee shop in our neighborhood. Love the atmosphere and the quality.",
        name: "Lisa K.",
        location: "Queen Creek, AZ",
        avatarId: 25,
      },
    ],
    testimonialsTitle: "What Our Regulars Say",
    hours: [
      "Mon-Fri: 6:00 AM - 4:00 PM",
      "Saturday: 7:00 AM - 3:00 PM",
      "Sunday: 7:00 AM - 2:00 PM",
    ],
    contactFormTitle: "Get in touch",
  },

  "bella-lash-studio": {
    name: "Bella Lash Studio",
    slug: "bella-lash-studio",
    phone: "(480) 555-1234",
    email: "hello@bellalash.com",
    address: "456 Rose Avenue, Suite 102, Queen Creek, AZ 85142",
    colors: {
      primary: "#831843",
      secondary: "#F9A8D4",
      bg: "#FFFFFF",
      accent: "#BE185D",
      text: "#1F2937",
      lightBg: "#FDF2F8",
    },
    headingFont: "'Cormorant Garamond', Georgia, serif",
    navItems: ["Services", "About", "Book Now"],
    ctaText: "Book Now",
    heroImage: IMG.lash.hero,
    heroTitle: "Lash Extensions & Brow Design",
    heroSubtitle:
      "Where beauty meets craftsmanship. Elevate your look at Queen Creek's premier lash studio.",
    servicesTitle: "Our Services",
    servicesLayout: "priceList",
    services: [
      { name: "Classic Full Set", price: "$150" },
      { name: "Hybrid Lashes", price: "$175" },
      { name: "Volume Lashes", price: "$200" },
      { name: "Mega Volume", price: "$225" },
      { name: "Lash Lift & Tint", price: "$85" },
      { name: "Brow Lamination", price: "$65" },
      { name: "Brow Tint", price: "$35" },
      { name: "Lash Fill (2 weeks)", price: "$75" },
    ],
    aboutTitle: "Meet Bella",
    aboutText:
      "With over 8 years of experience in lash artistry, Bella founded this studio with a simple mission: make every client feel confident and beautiful. Every set of lashes is customized to your eye shape, lifestyle, and personal style.",
    aboutText2:
      "We use only premium, cruelty-free products and maintain the highest standards of hygiene. Your comfort and safety are our top priorities.",
    aboutImage: IMG.lash.salon,
    testimonials: [
      {
        quote:
          "Bella is an absolute artist. My lashes look incredible and feel so natural.",
        name: "Jessica T.",
        location: "Gilbert, AZ",
        avatarId: 32,
      },
      {
        quote:
          "Best lash studio in the Valley. Clean, professional, and the results speak for themselves.",
        name: "Amanda L.",
        location: "Queen Creek, AZ",
        avatarId: 44,
      },
      {
        quote:
          "I've been coming to Bella for over a year. Wouldn't trust anyone else with my lashes.",
        name: "Rachel M.",
        location: "Chandler, AZ",
        avatarId: 47,
      },
    ],
    testimonialsTitle: "Client Love",
    hours: [
      "Tuesday - Friday: 9:00 AM - 7:00 PM",
      "Saturday: 9:00 AM - 5:00 PM",
      "Sunday - Monday: Closed",
    ],
    contactFormTitle: "Book Your Appointment",
  },

  "mesa-pro-plumbing": {
    name: "Mesa Pro Plumbing",
    slug: "mesa-pro-plumbing",
    phone: "(480) 555-1234",
    email: "service@mesapro.com",
    address: "789 Industrial Blvd, Mesa, AZ 85201",
    colors: {
      primary: "#1E3A5F",
      secondary: "#FACC15",
      bg: "#F8FAFC",
      accent: "#DC2626",
      text: "#0F172A",
      lightBg: "#EFF6FF",
    },
    headingFont: "'Bebas Neue', Impact, sans-serif",
    navItems: ["Services", "Reviews", "About"],
    ctaText: "Get Quote",
    heroImage: IMG.plumbing.hero,
    heroTitle: "When Plumbing Fails, We Win.",
    heroSubtitle:
      "Licensed & insured plumbers serving Mesa, AZ since 2008. Fast, reliable, fair prices.",
    badge: "LIC #ROC-12345 \u2022 BONDED & INSURED",
    servicesTitle: "What We Do",
    servicesLayout: "grid",
    services: [
      { name: "Emergency Repairs", desc: "24/7 same-day response" },
      { name: "Water Heaters", desc: "Install, repair & replace" },
      { name: "Drain Cleaning", desc: "Camera inspection included" },
      { name: "Leak Detection", desc: "Non-invasive technology" },
      { name: "Sewer Lines", desc: "Repair & replacement" },
      { name: "Pipe Repair", desc: "All types, all sizes" },
      { name: "Fixture Install", desc: "Sinks, faucets, toilets" },
      { name: "Repiping", desc: "Whole-home solutions" },
    ],
    aboutTitle: "Family-Owned Since 2008",
    aboutText:
      "Mesa Pro Plumbing is a family-owned and operated company serving the East Valley. We believe in honest pricing, quality work, and treating your home like our own. Every technician is licensed, background-checked, and trained to the highest standards.",
    aboutImage: IMG.plumbing.work,
    testimonials: [
      {
        quote:
          "Had a burst pipe at midnight. They were here within the hour. Saved us from a disaster.",
        name: "Mike R.",
        location: "Mesa, AZ",
        avatarId: 15,
      },
      {
        quote:
          "Upfront pricing, no surprises. Replaced our water heater for exactly what they quoted.",
        name: "Karen S.",
        location: "Gilbert, AZ",
        avatarId: 28,
      },
      {
        quote:
          "Professional, clean, and on time. This is how plumbing companies should operate.",
        name: "Tom H.",
        location: "Chandler, AZ",
        avatarId: 8,
      },
    ],
    testimonialsTitle: "Customer Reviews",
    hours: [
      "Monday - Friday: 7:00 AM - 6:00 PM",
      "Saturday: 8:00 AM - 2:00 PM",
      "Emergency: 24/7",
    ],
  },

  "wild-bloom-florals": {
    name: "Wild Bloom Florals",
    slug: "wild-bloom-florals",
    phone: "(480) 555-1234",
    email: "hello@wildbloom.com",
    address: "321 Bloom Street, Queen Creek, AZ 85142",
    colors: {
      primary: "#166534",
      secondary: "#FECDD3",
      bg: "#F7F5F0",
      accent: "#BE185D",
      text: "#292524",
      lightBg: "#F0FDF4",
    },
    headingFont: "'Cormorant Garamond', Georgia, serif",
    navItems: ["Shop", "Weddings", "About"],
    ctaText: "Order Flowers",
    secondaryCta: "Custom Orders",
    heroImage: IMG.flowers.hero,
    heroTitle: "Wild Bloom Florals",
    heroSubtitle:
      "Fresh flowers for every occasion. Handcrafted arrangements delivered in Queen Creek and Gilbert.",
    servicesTitle: "Shop by Occasion",
    servicesLayout: "cards",
    services: [
      { name: "Weddings", desc: "From bridal bouquets to ceremony arches" },
      { name: "Events", desc: "Corporate, parties, and celebrations" },
      { name: "Daily Arrangements", desc: "Beautiful bouquets for any day" },
    ],
    aboutTitle: "Meet Sarah",
    aboutText:
      "I started Wild Bloom out of my garage with a bucket of dahlias and a dream. Today, we're Queen Creek's go-to florist for weddings, events, and everyday beauty. Every arrangement is made by hand, with love, using the freshest seasonal flowers.",
    aboutImage: IMG.flowers.florist,
    testimonials: [
      {
        quote:
          "Sarah did our wedding flowers and they were absolutely breathtaking. Every detail was perfect.",
        name: "Emily & James",
        location: "Queen Creek, AZ",
        avatarId: 35,
      },
      {
        quote:
          "The weekly subscription is the best thing I've done for myself. Fresh flowers every Tuesday!",
        name: "Rachel B.",
        location: "Gilbert, AZ",
        avatarId: 41,
      },
      {
        quote:
          "Ordered an arrangement for my mom's birthday. She cried. Wild Bloom never disappoints.",
        name: "Carlos M.",
        location: "San Tan Valley, AZ",
        avatarId: 19,
      },
    ],
    testimonialsTitle: "Kind Words",
    hours: [
      "Monday - Saturday: 8:00 AM - 6:00 PM",
      "Sunday: 9:00 AM - 3:00 PM",
    ],
  },

  "desert-sun-landscaping": {
    name: "Desert Sun Landscaping",
    slug: "desert-sun-landscaping",
    phone: "(480) 555-1234",
    email: "info@desertsun.com",
    address: "Queen Creek, AZ",
    colors: {
      primary: "#15803D",
      secondary: "#FBBF24",
      bg: "#FFFFFF",
      accent: "#EA580C",
      text: "#1F2937",
      lightBg: "#F0FDF4",
    },
    headingFont: "'Plus Jakarta Sans', sans-serif",
    navItems: ["Services", "About", "Contact"],
    ctaText: "Free Estimate",
    secondaryCta: "View Our Work",
    heroImage: IMG.landscape.hero,
    heroTitle: "Transform Your Property.",
    heroSubtitle:
      "Professional landscaping for the Arizona Valley. Family-owned since 2012. Licensed & insured.",
    servicesTitle: "Our Services",
    servicesLayout: "grid",
    services: [
      { name: "Lawn Maintenance", desc: "Weekly mowing, edging & cleanup" },
      { name: "Irrigation Systems", desc: "Install, repair & optimize" },
      { name: "Hardscaping", desc: "Pavers, retaining walls, patios" },
      { name: "Tree Trimming", desc: "Professional tree & palm care" },
      { name: "Xeriscaping", desc: "Beautiful desert-friendly designs" },
      { name: "Sod Installation", desc: "Premium turf, expert install" },
      { name: "Outdoor Lighting", desc: "Landscape & security lighting" },
      { name: "Seasonal Cleanup", desc: "Fall & spring property prep" },
    ],
    aboutTitle: "Family-Owned Since 2012",
    aboutText:
      "Desert Sun was founded by Mike and his son Jake with a simple goal: make every yard in the Valley beautiful. We treat every property like our own and take pride in the transformations we create.",
    aboutImage: IMG.landscape.garden,
    testimonials: [
      {
        quote:
          "They transformed our backyard from a dirt lot into an oasis. Couldn't be happier.",
        name: "Steve & Linda",
        location: "Queen Creek, AZ",
        avatarId: 17,
      },
      {
        quote:
          "Reliable, fair pricing, and the work speaks for itself. Best landscapers in the Valley.",
        name: "Mark T.",
        location: "San Tan Valley, AZ",
        avatarId: 22,
      },
      {
        quote:
          "Our irrigation system works perfectly now. Should have called them months ago.",
        name: "Janet W.",
        location: "Gilbert, AZ",
        avatarId: 33,
      },
    ],
    hours: [
      "Monday - Friday: 6:00 AM - 5:00 PM",
      "Saturday: 7:00 AM - 12:00 PM",
      "Sunday: Closed",
    ],
  },

  "fetch-and-fresh": {
    name: "Fetch & Fresh Pet Grooming",
    slug: "fetch-and-fresh",
    phone: "(480) 555-1234",
    email: "woof@fetchfresh.com",
    address: "890 Pet Parkway, Queen Creek, AZ 85142",
    colors: {
      primary: "#EA580C",
      secondary: "#FED7AA",
      bg: "#FFFBEB",
      accent: "#2563EB",
      text: "#1E293B",
      lightBg: "#FFF7ED",
    },
    headingFont: "'Nunito', sans-serif",
    navItems: ["Services", "Pricing", "Book"],
    ctaText: "Book a Groom",
    heroImage: IMG.pet.hero,
    heroTitle: "Happy Pets, Happy Parents.",
    heroSubtitle:
      "Professional dog & cat grooming in Queen Creek. Stress-free, cage-free, always with love.",
    servicesTitle: "Our Services",
    servicesLayout: "pills",
    services: [
      { name: "Full Groom" },
      { name: "Bath & Brush" },
      { name: "Nail Trim" },
      { name: "De-Shedding" },
      { name: "Teeth Cleaning" },
      { name: "Puppy's First Groom" },
      { name: "Cat Grooming" },
      { name: "Flea Treatment" },
    ],
    aboutTitle: "Meet Our Team",
    aboutText:
      "At Fetch & Fresh, every pet is treated like family. Our certified groomers have over 15 years of combined experience and a genuine love for animals. We use premium, hypoallergenic products and maintain a calm, cage-free environment.",
    aboutImage: IMG.pet.groomed,
    testimonials: [
      {
        quote:
          "My golden retriever has never looked better! He actually gets excited to go to Fetch & Fresh.",
        name: "Jennifer K.",
        location: "Queen Creek, AZ",
        avatarId: 42,
      },
      {
        quote:
          "They're so gentle with my anxious rescue. Only groomers she doesn't shake at.",
        name: "Chris P.",
        location: "Gilbert, AZ",
        avatarId: 14,
      },
      {
        quote:
          "Fair prices, amazing results. My poodle looks like a show dog every time.",
        name: "Diana R.",
        location: "San Tan Valley, AZ",
        avatarId: 48,
      },
    ],
    hours: [
      "Monday - Friday: 8:00 AM - 5:00 PM",
      "Saturday: 8:00 AM - 3:00 PM",
      "Sunday: Closed",
    ],
  },

  "golden-crust-bakery": {
    name: "Golden Crust Bakery",
    slug: "golden-crust-bakery",
    phone: "(480) 555-1234",
    email: "hello@goldencrust.com",
    address: "654 Baker Lane, Queen Creek, AZ 85142",
    colors: {
      primary: "#92400E",
      secondary: "#FEF3C7",
      bg: "#FFFBEB",
      accent: "#B91C1C",
      text: "#1C1917",
      lightBg: "#FFF8EE",
    },
    headingFont: "'Lora', Georgia, serif",
    navItems: ["Menu", "Custom Cakes", "Visit"],
    ctaText: "Order Pickup",
    secondaryCta: "See Today's Menu",
    heroImage: IMG.bakery.hero,
    heroTitle: "Baked Fresh. Every Morning.",
    heroSubtitle:
      "A neighborhood bakery in Queen Creek. Artisan breads, pastries, and custom cakes since 2019.",
    servicesTitle: "Our Menu",
    servicesLayout: "menu",
    services: [
      {
        category: "BREADS",
        items:
          "Sourdough Loaf, Focaccia, French Baguette, Rye Bread, Ciabatta, Whole Wheat",
      },
      {
        category: "PASTRIES",
        items:
          "Butter Croissants, Pain au Chocolat, Danish, Blueberry Scones, Muffins, Cinnamon Rolls",
      },
      {
        category: "CUSTOM CAKES",
        items:
          "Wedding Cakes, Birthday Cakes, Cupcakes, Special Occasion, Sheet Cakes",
      },
      {
        category: "SEASONAL",
        items:
          "Pumpkin Bread (Fall), Gingerbread (Winter), Strawberry Tarts (Spring), Lemon Bars (Summer)",
      },
    ],
    aboutTitle: "From Our Oven to Your Table",
    aboutText:
      "Golden Crust started with a simple sourdough recipe and a dream. Every morning at 3 AM, we fire up the ovens and start baking. No shortcuts, no preservatives, just real ingredients and traditional techniques. We believe bread should taste like bread used to.",
    aboutImage: IMG.bakery.baker,
    testimonials: [
      {
        quote:
          "The sourdough alone is worth the trip. Nothing else in Queen Creek comes close.",
        name: "Paul G.",
        location: "Queen Creek, AZ",
        avatarId: 9,
      },
      {
        quote:
          "They made our wedding cake and it was the most beautiful thing at the reception.",
        name: "Amy & Tyler",
        location: "Gilbert, AZ",
        avatarId: 36,
      },
      {
        quote: "Best croissants outside of Paris. I'm not even exaggerating.",
        name: "Marie D.",
        location: "Chandler, AZ",
        avatarId: 50,
      },
    ],
    testimonialsTitle: "What Our Neighbors Say",
    hours: [
      "Tuesday - Sunday: 6:00 AM - 2:00 PM",
      "Monday: Closed",
      "Order ahead: call by 5 PM day before",
    ],
  },
};

export const SITE_LIST = Object.values(SITES);
